
<template>
  <div class="pdf-document" v-if="page">
    <PDFPage v-bind="{page, scale}"/>
  </div>
</template>

<script>
import PDFPage from "./PDFPage";
import range from "lodash/range";
export default {
  components: {
    PDFPage
  },
  props: ["url", "scale"],
  data() {
    return {
      pdf: undefined,
      pages: [],
      pageNumber: 1,
      page: null
    };
  },
  created() {
    this.fetchPDF();
  },
  watch: {
    pdf(pdf) {
      const promise = pdf.getPage(this.pageNumber);
      promise.then(page => {
        this.page = page;
      });
    }
  },
  methods: {
    fetchPDF() {
      import("pdfjs-dist/webpack")
        .then(pdfjs => pdfjs.getDocument(this.url))
        .then(pdf => (this.pdf = pdf));
    }
  }
};
</script>


// WEBPACK FOOTER //
// ClientApp/app/technicaldocumentation/components/PDFDocument.vue